import { ethers } from 'ethers';
import addressData from './addresses.json';

// export async function getAddress(contractName, network) {
//     const module = await import(`./deployments/${network}/${contractName}.json`);
//     const { address } = module;
//     return address;
// }

export async function getAddress(contractName, network) {
  return addressData[network][contractName];
}

export async function getABI(contractName, network) {
    const module = await import(`./deployments/${contractName}.sol/${contractName}.json`);
    const { abi } = module;
    return abi;
}

export function fromExponential(expString) {
    const [significand, exponent] = expString.split('e');
    if (+exponent > 0) {
        const [lead, decimal] = significand.split('.');
        const newDecimal = (decimal || '').substr(0, +exponent);
        const remainder = (decimal || '').substr(+exponent);
        return lead + newDecimal + '.' + remainder;
    } else {
        const base = significand.replace('.', '');
        const zeros = Math.abs(exponent) - 1;
        return '0.' + '0'.repeat(zeros) + base;
    }
}

export function tickToPrice(tick, token0Decimals=18, token1Decimals=18){
	let price0 = (1.0001**tick)/(10**(token1Decimals-token0Decimals));
	let price1 = 1 / price0;
	return [price0.toFixed(token1Decimals), price1.toFixed(token0Decimals)]
}

  
const getRevertReason = (errorString) => {
  const pattern = /execution reverted: ([^,"'\n]+)/;
  const match = errorString.match(pattern);
  return match ? match[1].trim() : "Error message not found.";
};

export function extractErrorMessage(errorString) {
    const match = errorString.match(/execution (\d+ < \d+)/);
    if (match) {
      return match[0];
    } else {
      return getRevertReason(errorString);
    }
}

const networks = [
{
  name: "optimism",
  chainId: 10
},
{
  name: "ethereum",
  chainId: 1
},
{
  name: "ganache",
  chainId: 1337
},
{
  name: "bsc",
  chainId: 56
}
]

export const chainIdToNetwork = (chainId) => {
  for (let network of networks) {
    if (network.chainId === chainId) {
      return network.name;
    }
  }
  return null;  // Return null or any other default value if chainId is not found
}

export const commify = (number, numZeroes = 5) => {
  let numStr = number.toString();
  let [integerPart, decimalPart] = numStr.split(".");
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Adjust the decimal part based on numZeroes
  if (numZeroes > 0) {
      // Create a string of zeroes based on numZeroes parameter
      const zeroes = new Array(numZeroes + 1).join('0');
      // If decimalPart exists, append zeroes and slice; otherwise, use zeroes
      decimalPart = decimalPart ? `${decimalPart}${zeroes}`.slice(0, numZeroes) : zeroes;

      // Remove the dot if the decimal part is all zeros
      if (decimalPart.match(/^0+$/)) {
          return integerPart;  // return only the integer part if decimal is all zeros
      } else {
          return `${integerPart}.${decimalPart}`;
      }
  } else {
      // If numZeroes is 0, return only the integer part, never show the decimal part
      return integerPart;
  }
}
